import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { CarouselProvider, Slide, Slider } from 'pure-react-carousel';

import { WAIT_BEFORE_SLIDES_IS_ACTIVE } from './Constants';
import { useMatchMedia } from '../../../../hooks/useMatchMedia';
import promoBreakpoints from '../../../../theme/promoBreakpoints';
import promoMedia from '../../../../theme/promoMedia';
import { HighlightedTile } from '../highlighted-tile/HighlightedTile';

const Container = styled.div`
    margin: -24px -20px 8px -20px;

    ${promoMedia.tablet744} {
        margin: -24px -20px 24px -20px;
    }

    ${promoMedia.desktop1440} {
        margin: -24px -20px 40px -20px;
    }

    .carousel {
        ${promoMedia.tablet744} {
            max-width: 504px;
        }

        ${promoMedia.desktop1440} {
            max-width: 100%;
        }
    }
`;

const HighlightedTileSlide = styled.div`
    padding: ${(props) => (props.isFirstSlide ? '24px 6px 24px 24px' : '24px 6px')};
    min-height: 100%;
    box-sizing: border-box;
    display: flex;

    ${promoMedia.tablet744} {
        padding: ${(props) => (props.isFirstSlide ? '24px 12px 24px 24px' : '24px 12px')};
    }

    ${promoMedia.desktop1440} {
        padding: ${(props) => (props.isFirstSlide ? '24px 20px 24px 24px' : '24px 20px')};
    }
`;

export const HighlightedTilesSection = (props) => {
    const isDesktop = useMatchMedia(promoBreakpoints.desktop1440);
    const isTablet = useMatchMedia(promoBreakpoints.tablet744);
    const hasData = props.data && Array.isArray(props.data);
    const isPlaying = isDesktop && hasData ? props.data.length > 3 : true;
    const totalSlides = hasData ? props.data?.length : null;

    const getVisibleSlides = () => {
        if (isDesktop) {
            return 3;
        } else {
            return isTablet ? 1.5 : 1.2;
        }
    };

    return (
        <Container>
            <CarouselProvider
                naturalSlideHeight="100%"
                naturalSlideWidth="100%"
                visibleSlides={getVisibleSlides()}
                totalSlides={totalSlides}
                isPlaying={isPlaying}
                interval={WAIT_BEFORE_SLIDES_IS_ACTIVE}
                isIntrinsicHeight
                infinite
            >
                <Slider>
                    {hasData &&
                        props.data
                            .filter((item) => item !== null)
                            .map((item, index) => {
                                return (
                                    <Slide index={index} key={item.id}>
                                        <HighlightedTileSlide isFirstSlide={index === 0}>
                                            <HighlightedTile
                                                promoDarkPage={props.promoDarkPage}
                                                icon={item.icon}
                                                title={item.title}
                                                titleH2={props.titleH2}
                                                text={item.text}
                                                color={item.color?.titleColor}
                                                titleGradient={item.color?.titleGradient}
                                                bgColor={item.color?.bgColor}
                                                variant="plain"
                                            />
                                        </HighlightedTileSlide>
                                    </Slide>
                                );
                            })}
                </Slider>
            </CarouselProvider>
        </Container>
    );
};

HighlightedTilesSection.propTypes = {
    data: PropTypes.array,
    titleH2: PropTypes.bool,
};
